import { FilterDef } from "@/stores/filters/FilterDef";

export class AgendaFilterDef extends FilterDef {



}
